import React from 'react';
import {observer} from "mobx-react-lite";
import Indiv from '../modules/Indiv';
import { Layout } from '../modules/Layout';

export const UpdaterPage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Indiv/>
        </Layout>
    )
});
      